import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";

// Actions
import {
  addMedia,
  resetMediaUploads,
  updateMediaProgress
} from "src/state/media/actions";

// Hooks
import { useAppInsights } from "src/utils/telemetry/AppInsights";

// Components
import InlineFileUpload from "src/components/InlineFileUpload";
import Text from "src/components/Text";
import colors from "src/config/colors";

const useStyles = makeStyles(theme => ({
  subtitle: {
    marginBottom: theme.spacing(2),
    color: colors.santasGray
  }
}));

const EvidenceStep = forwardRef(({ caseId }, ref) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { trackException } = useAppInsights();
  const { uploadProgress, uploadErrors } = useSelector(state => state.media);

  React.useEffect(() => {
    dispatch(resetMediaUploads());
  }, [dispatch]);

  const handleProgress = index => progress => {
    dispatch(updateMediaProgress({ index, progress }));
  };

  const handleSubmit = files => {
    files.forEach((item, index) => {
      dispatch(
        addMedia({
          caseId,
          description: item.description,
          image: item.file,
          id: index,
          onUploadProgress: handleProgress(index),
          onFail: () => trackException(`Failed to add media to case: ${caseId}`)
        })
      );
    });
  };

  return (
    <>
      <Text
        className={classes.subtitle}
        text="createCasePage.newCaseFlow.evidenceEmpty"
        type="contentLabel2"
      />
      <InlineFileUpload
        ref={ref}
        multiple
        onSubmit={handleSubmit}
        placeholderText="mediaPage.emptyPlaceholder"
        uploadErrors={uploadErrors}
        uploadProgress={uploadProgress}
      />
    </>
  );
});

EvidenceStep.propTypes = {
  caseId: PropTypes.string.isRequired
};

export default EvidenceStep;
